<template>
    <b-modal
        :id="'assignment-edit-answer-options-modal-' + partIn.id"
        :title="$t('assignment.edit_answers_choice_list')"
        ok-only
        :ok-title="$t('common.save')"
        ok-variant="primary"
        v-model="modal"
        modal-class="apprentice-default-modal">
        <div class="standard-select-list-answers">
            <div class="standard-select-list-answers-options">
                <div class="options">
                    <div
                        class="option"
                        v-for="option in part.list_options"
                        :key="option.id">
                        <b-input-group>
                            <b-form-input
                                id="standard-select-list-answers-options"
                                :value="option.value"
                                @change="updateOption($event, option)">
                            </b-form-input>
                            <b-input-group-append>
                                <b-button
                                    class="btn-remove btn-remove-answer-option"
                                    variant="danger-icon"
                                    @click="deleteOption(option)"
                                    :disabled="partIn.list_options.length === 1">
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </div>
                </div>
                <b-button
                    class="btn-add btn-add-option"
                    variant="primary"
                    @click="addOption()">
                    {{ $t('assignment.new_answer_choice') }}
                </b-button>
            </div>
        </div>
    </b-modal>
</template>

<script>
    export default {
        name: 'design-2021-assignment-edit-answer-options-modal',
        props: {
            partIn: Object,
            ords: Boolean,
        },
        data() {
            return {
                part: this.partIn,
                optionsCount: this.partIn.list_options.length,
                modal: false,
            };
        },
        methods: {
            show() {
                this.modal = true;
            },
            addOption() {
                this.alert.saving(this.$t('assignment.add_option'), this.$t('assignment.option_being_added'));

                const data = {
                    value: '',
                };

                this.axios.post(this.routes.assignmentPartListOptionAdd(this.partIn.id), data).then(
                    (response) => {
                        if (this.ords) {
                            this.partIn.addRelation('list_options', response.data);
                        } else {
                            this.part.list_options.push(response.data);
                        }
                        this.$emit('part-updated', this.part);
                        this.alert.success();
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    }
                );
            },

            deleteOption(option) {
                this.alert.saving(this.$t('assignment.delete_option'), this.$t('assignment.option_being_deleted'));
                this.axios.delete(this.routes.assignmentPartListOptionDelete(this.partIn.id, option.id)).then(
                    (response) => {
                        if (this.ords) {
                            option.remove();
                        } else {
                            this.part.list_options = this.part.list_options.filter((listOption) => listOption.id !== option.id);
                        }
                        this.$emit('part-updated', this.part);
                        this.alert.success();
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    }
                );
            },

            updateOption(value, option) {
                const data = {
                    value: value
                };

                this.axios.post(this.routes.assignmentPartListOptionUpdate(this.partIn.id, option.id), data).then(
                    (response) => {
                        if (this.ords) {
                            option.update({ value: response.data.value });
                        } else {
                            this.part.list_options = this.part.list_options.map((oldOption) => {
                                return oldOption.id === option.id
                                    ? response.data
                                    : oldOption;
                            });
                        }

                        this.$emit('part-updated', this.part);
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    }
                );
            }
        },
        watch: {
            partIn: function(value) {
                this.part = value;
            }
        }
    };
</script>

<style scoped lang="scss">
    input {
        &:active,
        &:focus {
            box-shadow: none;
            outline: none;
        }
    }

    .option {
        display: flex;
        margin-bottom: map-get($grid-gutter-spacing, 'fifteen');

        &:focus-within {
            box-shadow: 0 0 0 0.2rem rgba($primary, 0.25);
        }
    }

    .btn-remove-answer-option {
        align-items: center;
        font-size: 1.3125rem;

        &:before,
        &:after {
            align-self: center;
        }
    }
</style>
